import React from "react";
import {
  Box,
  Button,
  Col,
  Divider,
  Flex,
  Gap,
  InputField,
  Row,
  SelectField,
  Switchbox,
  Typography,
} from "../../../ppui";
import { Snackbar } from "../../../ppui/snackbar";
import useCommonfn from "../../../utils/useCommonfn";
import {
  CustomTable,
  CustomTableBody,
  CustomTableHeader,
  Td,
  Th,
  Tr,
} from "../../style";
import StatutoryPtaxStatusView from "./p-tax-status";
import { TAX_INPUT_FIELDS } from "./ptax-constant";
import usePTaxService from "./use-ptax-service";

function StatutoryPTax() {
  const { navigateToDashBoard } = useCommonfn()
  const {
    handleDisableAllPTaxFn,
    handleSubmitFn,
    esiInputs,
    getInputFieldPropsFn = () => { },
    createUpdateLoading,
    stateList,
    pTaxListInfo,
    pTaxInfo,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    setOpenPtaxModal,
    handleOpenStatutoryPtaxModal,
    handleCloseStatutoryPtaxModal,
    handleDisableAllPTaxFnMOdal
  } = usePTaxService();

  return (
    !esiInputs?.org_ptax_id || !esiInputs?.status ?
      <>
        <Flex justifyContent="space-between" mb={20}>
          <Box>
            <Typography variant="h5" mb={"0"}>
              P-Tax Status
            </Typography>
          </Box>
          <Switchbox
            color="Primary"
            size="lg"
            lableFirst
            label={`${!esiInputs.status ? "Enable" : "Disable"}  P-Tax Status`}
            checked={esiInputs.status} onChange={handleDisableAllPTaxFn}
          />
        </Flex>
        <Row rowGap>
          <Col sm={12} md={6} lg={4} xxl={3}>
            <InputField
              {...getInputFieldPropsFn(TAX_INPUT_FIELDS.ptax_ec_code.name)}
              disabled={!esiInputs?.status}

            />
          </Col>
          <Col sm={12} md={6} lg={4} xxl={3}>
            <InputField
              {...getInputFieldPropsFn(TAX_INPUT_FIELDS.ptax_rc_code.name)}
              disabled={!esiInputs?.status}
            />
          </Col>
          <Col sm={12} md={6} lg={4} xxl={3}>
            <SelectField
              {...getInputFieldPropsFn(TAX_INPUT_FIELDS.state.name)}
              disabled={!esiInputs?.status}
              options={stateList}
            />
          </Col>
          <Col sm={12} md={6} lg={4} xxl={3}>
            <SelectField
              {...getInputFieldPropsFn(TAX_INPUT_FIELDS.financial_year.name)}
              options={pTaxListInfo.ptaxYearList || []}
              disabled={!esiInputs?.status}
            />
          </Col>
        </Row>
        {(esiInputs.status && pTaxInfo?.tax_cal?.length > 0) &&
          <>
            <Divider gap={20} />
            <Typography variant="h5">Professional Tax Slab</Typography>
            <Row>
              <Col sm={12} md={10}>
                <CustomTable>
                  <CustomTableHeader>
                    <Tr>
                      <Th>
                        <Typography variant="body1" mb={"0"}>
                          MONTHLY GROSS SALARY (₹)
                        </Typography>
                      </Th>

                      <Th>
                        <Typography variant="body1" mb={"0"}>
                          MONTHLY TAX AMOUNT (₹)
                        </Typography>
                      </Th>
                    </Tr>
                  </CustomTableHeader>
                  <CustomTableBody>
                    {
                      pTaxInfo?.tax_cal?.map(it => (
                        <Tr key={it?.salary}>
                          <Td>
                            <Typography variant="body1" mb={"0"}>
                              {it?.min_salary} - {it?.max_salary || "Above"}
                            </Typography>
                          </Td>
                          <Td>
                            <Typography variant="body1" mb={"0"}>
                              {it?.tax_amount}
                            </Typography>
                          </Td>
                        </Tr>
                      ))
                    }
                  </CustomTableBody>
                </CustomTable>
              </Col>
            </Row>
          </>
        }
        <Gap height={50} />
        <Flex justifyContent="flex-end" gap={"10"}>
          <Button disabled={!esiInputs.status} onClick={navigateToDashBoard} variant="outlined">
            Cancel
          </Button>
          <Button color="primary" disabled={!esiInputs.status} loading={createUpdateLoading} onClick={handleSubmitFn} variant="contained">
            Save
          </Button>
        </Flex>
        <Snackbar
          message={snackbarMessage}
          color={snackColor}
          variant="contained"
          size="medium"
          position="top-right"
          onClose={closeSnackbar}
          onOpen={snackbarVisible}
          loading={false}
          duration={3000}
        />
      </>
      :
      <StatutoryPtaxStatusView
        pTaxViewData={esiInputs}
        pTaxInfo={pTaxInfo}
        getInputFieldPropsFn={getInputFieldPropsFn}
        stateList={stateList}
        pTaxListInfo={pTaxListInfo}
        handleDisableAllPTaxFn={handleDisableAllPTaxFnMOdal}
        esiInputs={esiInputs}
        handleSubmitFn={handleSubmitFn}
        createUpdateLoading={createUpdateLoading}
        setOpenPtaxModal={setOpenPtaxModal}
        handleOpenStatutoryPtaxModal={handleOpenStatutoryPtaxModal}
        handleCloseStatutoryPtaxModal={handleCloseStatutoryPtaxModal}
      />
  );
}

export default StatutoryPTax;
